import React, { useEffect, useState } from "react";
import { Button, Input, Pagination, Table, Tooltip, Whisper } from "rsuite";
import { handleDownloadAsExcel } from "../../../Helpers/Utils";
import { ProcessesVM } from "../../../Models/ViewModels";
import { GetProcessDetails } from "../../../Services/ProcessDB";
import { BootstrapIcon } from "../../../SharedComponents/BootstrapIcon";
import { CustomTableCell } from "../../../SharedComponents/CustomTableCell";
import { CustomTableHeaderCell } from "../../../SharedComponents/CustomTableHeaderCell";
import { PageHeader } from "../../../SharedComponents/PageHeader";
import { ProcessModal } from "./ProcessModalDisp";
const { Column, HeaderCell, Cell } = Table;
export const ProcessList = () => {
  const [cachedProcessList, setCachedProcessList] = useState(
    new Array<ProcessesVM>()
  );
  const [sortType, setSortType] = useState();

  const [sortColumn, setSortColumn] = useState();
  const [isLoading, setLoading] = useState(true);
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(10);
  const [filteredProcessList, setFilteredProcessList] = useState(
    new Array<ProcessesVM>()
  );

  const [searching, setSearching] = useState(false);

  useEffect(() => {
    GetProcessList();
  }, []);

  const GetProcessList = () => {
    GetProcessDetails().then((res: any) => {
      setCachedProcessList(res.data);
      setFilteredProcessList(res.data);
      setLoading(false);
    });
  };

  const handleFilterData = (val: string, e: any) => {
    let searchText = val;
    setPage(1);
    if (searchText) {
      setFilteredProcessList(
        cachedProcessList.filter((e) =>
          JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
        )
      );
      setSearching(true);
    } else {
      setFilteredProcessList([...cachedProcessList]);
      setSearching(false);
    }
  };

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const tableDataFeed = filteredProcessList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
    if (sortColumn && sortType) {
      return filteredProcessList.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };

  const ProcessInfo: ProcessesVM = new ProcessesVM();

  const addProcess = (prrDetail: ProcessesVM) => {
    GetProcessList();
  };
  const editProcess = (prrDetail: ProcessesVM) => {
    GetProcessList();
  };
  const deleteProcess = (prrDetail: ProcessesVM) => {
    GetProcessList();
  };
  return (
    <>
      <div className="row">
        <div className="col-md-7">
          <PageHeader title="Process Master" backPage="">
            <></>
          </PageHeader>
        </div>
        <div className="col-md-3">
          <Input
            className="form-control border border-dark"
            placeholder="Search..."
            type={"search"}
            id="search"
            onChange={handleFilterData}
          />
        </div>
        <div className="col-md-1">
          {searching == true ? (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(tableDataFeed)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={30}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          ) : (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(cachedProcessList)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={35}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          )}
        </div>
        <div className="col">
          <ProcessModal
            action="add"
            data={ProcessInfo}
            cachedData={cachedProcessList}
            onAction={addProcess}
          />
          <br />
        </div>
        <hr />
      </div>

      <div className="show-container " bg-color="pink">
        <Table
          id="table"
          data={tableDataFeed}
          loading={isLoading}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          bordered={true}
          cellBordered={true}
          className="border border-dark mt-2"
          autoHeight={true}
          rowHeight={30}
          headerHeight={30}
        >
          <Column width={157} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"ID"}>ID</CustomTableHeaderCell>
            <CustomTableCell dataKey="ProcessID" />
          </Column>

          <Column width={300} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"Process Name"}>
              Process Name
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="ProcessName" />
          </Column>

          <Column width={270} align="center" fixed>
            <CustomTableHeaderCell placement={"Process Code"}>
              Process Code
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="ProcessCode" />
          </Column>

          <Column width={210} align="center" fixed sortable>
            <CustomTableHeaderCell placement={"Status"}>
              Status
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="IsActive" />
          </Column>
          <Column width={270} align="center" fixed>
            <CustomTableHeaderCell placement={"End Date"}>
              End Date
            </CustomTableHeaderCell>
            <CustomTableCell>
              {(rowData: ProcessesVM) => {
                if (rowData.EndDate === "") return <div></div>;
                else return <div>{rowData.EndDate}</div>;
              }}
            </CustomTableCell>
          </Column>
          <Column width={130} align="center">
            <CustomTableHeaderCell placement={"Action"}>
              Action
            </CustomTableHeaderCell>
            <CustomTableCell>
              {(rowData: ProcessesVM) => {
                if (rowData.IsActive === "Active") {
                  return (
                    <div className="d-flex justify-content-center align-items-center flex-row gap-2">
                      <ProcessModal
                        action="delete"
                        data={rowData}
                        cachedData={cachedProcessList}
                        onAction={deleteProcess}
                      />
                      <ProcessModal
                        action="edit"
                        data={rowData}
                        cachedData={cachedProcessList}
                        onAction={editProcess}
                      />
                    </div>
                  );
                } else {
                  return (
                    <BootstrapIcon
                      bootStrapIconName="x-circle-fill text-danger"
                      size={15}
                      cssClasses="me-1"
                    ></BootstrapIcon>
                  );
                }
              }}
            </CustomTableCell>
          </Column>
        </Table>

        {filteredProcessList && (
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="md"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={filteredProcessList.length}
              limitOptions={[10, 15, 20, 25, 30]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        )}
      </div>
    </>
  );
};
